import { Component, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { SearchComponent } from '../../components/common/search/search.component';
import { LoggedInUser, LoggedInUserService } from '../../auth/logged.in.user';
import { MatchingTenderSearchRequest, MatchingTenderSummaryDto, CheckTenderDto } from '../../models/tenders/matching.tender.models';
import { MatchingTenderService } from '../../services/matching.tender.service';
import { SelectableItem } from '../../models/common/selectableItem';
import { SortOption } from '../../models/tenders/sort.option';
import { BlockUI } from 'ng-block-ui';
import { DateRangeModel } from '../../models/common/date.range';
import { TenderType } from '../../models/tenders/tender.enums';
import { CmsDialogService } from '../../services/cms.dialog.service';
import { CmsDialogDto } from '../../models/cms.dialogs/cms.dialogs.models';
import { PermissionsHub } from '../../signalr/permissions.hub';
import { AuthService } from '../../auth/auth.service';
import { RouterService } from '../../services/routerService';
import { appInsights } from '../../app.module';

@Component({
    selector: 'tenders/mymatches',
    template: require('./my.matches.component.html'),
    styles: [require('./my.matches.component.css')],
    encapsulation: ViewEncapsulation.None
})
export class MyMatchesComponent extends SearchComponent<MatchingTenderSearchRequest,
    MatchingTenderSummaryDto> implements OnInit {
    private readonly fromUrlKey = 'matchingTenderId';
    
    options: Array<SelectableItem<number>>;

    sortOptions = <SortOption[]>[];
    selectedSortOption: SortOption;
    sortOptionId: number;

    errorMessage: string;

    showSearch = true;

    resultOptions;
    multiSelect: Array<number>;

    deadlineDate: DateRangeModel;
    loading: boolean = false;

    dialogName: string;
    dialogHeader: string;
    dialogBody: string;

    freePinName: string;
    freePinHeader: string;
    freePinBody: string;

    csvDialogHeader: string;
    csvDialogBody: string;

    subscribed: boolean;
    clicked: boolean;

    private readonly user: LoggedInUser;

    @BlockUI('tender-results-block') private resultsBlock;
    @ViewChild('deleteModal', { static: false }) private deleteModal: any;
    @ViewChild('resultsPage', { static: false }) private resultsView;

    constructor(private matchingTenderService: MatchingTenderService, helpers: Helpers, private readonly configuration: Configuration,
        loggedInUserService: LoggedInUserService,
        private readonly cmsDialogService: CmsDialogService,
        private authService: AuthService) {
        super(new MatchingTenderSearchRequest(configuration), matchingTenderService, helpers);

        this.user = loggedInUserService.getCurrentUser();

        this.subscribed = !this.user.canAdHoc('notSubscribed');

        if (!this.subscribed) {
            var idx = this.request.types.indexOf(TenderType.PinHigh);
            this.request.types.splice(idx, 1);
            var idx2 = this.request.types.indexOf(TenderType.PinLow);
            this.request.types.splice(idx2, 1);
        }

        this.request.supplierId = loggedInUserService.getCurrentUser().supplierId;
        this.request.excludeBookmarked = false;
        this.request.excludeViewed = false;
        this.request.excludeAssigned = false;
        this.clicked = false;

        this.sortOptionId = 1;

        this.selectedSortOption = {
            id: 1,
            sortProperty: 'DeadlineDate',
            descending: false
        };

        this.sortOptions = [
            this.selectedSortOption,
            {
                id: 2,
                sortProperty: 'DeadlineDate',
                descending: true
            },
            {
                id: 3,
                sortProperty: 'Type',
                descending: false
            },
            {
                id: 4,
                sortProperty: 'Title',
                descending: false
            },
            {
                id: 5,
                sortProperty: 'PublishedDate',
                descending: true
            },
            {
                id: 6,
                sortProperty: 'PublishedDate',
                descending: false
            },
        ];

        this.options = [
            {
                text: 'Nearest Deadline',
                value: 1
            },
            {
                text: 'Furthest Deadline',
                value: 2
            },
            {
                text: 'Type',
                value: 3
            },
            {
                text: 'Title',
                value: 4
            },
            {
                text: 'Most Recent Published',
                value: 5
            },
            {
                text: 'Oldest Published',
                value: 6
            },
        ];

        if (loggedInUserService.getCurrentUser().role === 'Supplier') {
            this.resultOptions = {
                availableButtons: ['removeResult', 'print', 'bookmark', 'assign', 'removeMultiple', 'sendToBidManagement']
            };
        }
        else {
            this.resultOptions = {
                availableButtons: ['print', 'bookmark']
            };
        }

        this.deadlineDate = new DateRangeModel();

        
    }

    ngOnInit() {
        document.body.classList.add('matching-tenders-fit');

        $('#invalid-tender-modal').modal();
        $('#invalid-tender-modal').modal('hide');
        $('#invalid-pin-modal').modal();
        $('#invalid-pin-modal').modal('hide');
        $('#incomplete-profile-modal').modal();
        $('#incomplete-profile-modal').modal('hide');

        this.authService.getProfileStatus().subscribe((response: { hasNoCategoriesOrLocations: boolean }) => {
            if (response && response.hasNoCategoriesOrLocations) {
                $('#incomplete-profile-modal').modal();
            }
        });

        if (this.subscribed) {
            this.dialogName = 'Matching Tenders Info - Subscribed';
        }
        else {
            this.dialogName = 'Matching Tenders Info - Not Subscribed';
        }

        this.freePinName = 'Free PIN Notice Info';

        this.cmsDialogService.getByDescription(this.dialogName).subscribe((result: CmsDialogDto) => {
            this.dialogHeader = result.header;
            this.dialogBody = result.body;
        });

        this.cmsDialogService.getByDescription(this.freePinName).subscribe((result: CmsDialogDto) => {
            this.freePinHeader = result.header;
            this.freePinBody = result.body;
        });

        this.cmsDialogService.getByDescription('Matching Tenders CSV Warning').subscribe((result: CmsDialogDto) => {
            this.csvDialogHeader = result.header;
            this.csvDialogBody = result.body;
        });

        PermissionsHub.startHub(this.authService, this.configuration, this.user.userId);

        var selectedId = localStorage.getItem(this.fromUrlKey);

        if (selectedId) {
            this.request.noticeId = JSON.parse(selectedId) as number;
            localStorage.removeItem(this.fromUrlKey);

            this.matchingTenderService.checkTender(this.request.noticeId).subscribe((result: CheckTenderDto) => {
                var isValid = result.isValid;

                if (!isValid) {
                    this.errorMessage = result.errorDetail;

                    if (!this.subscribed && this.errorMessage == 'PIN Notices are only available to paid subscribers.') {
                        $('#invalid-pin-modal').modal();
                    }
                    else {
                        $('#invalid-tender-modal').modal();
                    }
                }
            });
        }

        

        super.ngOnInit();
    }

    ngOnDestroy() {
        document.body.classList.remove('matching-tenders-fit');
        $('#matching-info-modal').modal('hide');
        $('#invalid-tender-modal').modal('hide');
        $('#invalid-pin-modal').modal('hide');
        $('#incomplete-profile-modal').modal('hide');
        $('#multi-modal').modal('hide');
        $('#delete-modal').modal('hide');
        $('#matching-csv-modal').modal('hide');
    }

    removeMatch(tender: MatchingTenderSummaryDto) {
        this.deleteModal.showAndPopulate(tender, tender.title);
    }

    removeMatches(ids: Array<number>) {
        this.multiSelect = ids;

        if (ids.length > 0) {
            $('#multi-modal').modal();
        }        
    }

    confirmMultiRemoval() {
        $('#multi-modal').modal('hide');
        this.matchingTenderService.removeMatches(this.multiSelect)
            .subscribe(() => {
                this.ngOnInit();
            });
    }

    confirmRemove(tender: MatchingTenderSummaryDto) {
        this.deleteModal.clearAndHide();

        this.matchingTenderService.removeMatch(tender.id)
            .subscribe(() => {
                var idx = this.results.data.indexOf(tender);

                if (idx > -1) {
                    this.results.data.splice(idx, 1);
                    this.results.totalRecords -= 1;
                }

                this.resultsView.clearSelectedIfMatch(tender.b2BRef);
            });
    }

    sortOptionChanged() {
        var id = +this.sortOptionId;
        this.selectedSortOption = this.sortOptions.find((option: SortOption) => {
            return option.id === id;
        });

        this.request.sortProperty = this.selectedSortOption.sortProperty;
        this.request.descending = this.selectedSortOption.descending;

        this.search();
    }

    changeTypeFilter(type: string) {
        switch (type) {
            case 'high':
                {
                    this.addOrRemoveTypeFromFilter(TenderType.High);
                    this.addOrRemoveTypeFromFilter(TenderType.PrivateB2B);
                    break;
                }
            case 'low':
                {
                    this.addOrRemoveTypeFromFilter(TenderType.Low);
                    break;
                }
            case 'pinHigh':
                {
                    this.addOrRemoveTypeFromFilter(TenderType.PinHigh);
                    break;
                }
            case 'pinLow':
                {
                    this.addOrRemoveTypeFromFilter(TenderType.PinLow);
                    break;
                }
            case 'private':
                {
                    this.addOrRemoveTypeFromFilter(TenderType.PrivateProject);
                    break;
                }
            default:
                break;
        }

        this.search();
    }

    changeExcludeFilter() {
        this.search();
    }

    addOrRemoveTypeFromFilter(type: TenderType) {
        var idx = this.request.types.indexOf(type);

        if (idx > -1) {
            this.request.types.splice(idx, 1);
            appInsights.trackEvent({
                name: 'TenderTypeRemoved',
                properties: {
                    type: type
                }
            });
        } else {
            this.request.types.push(type);
            appInsights.trackEvent({
                name: 'TenderTypeAdded',
                properties: {
                    type: type
                }
            });
        }
    }

    search() {
        this.loading = true;
        this.resultsBlock.start();

        var deadlineDateDto = this.deadlineDate.convertDatesToDto();

        this.request.deadlineDateFrom = deadlineDateDto.startDate;
        this.request.deadlineDateTo = deadlineDateDto.endDate;

        return super.search();
    }

    searchCallback(results) {
        super.searchCallback(results);

        if (this.resultsView) {
            this.resultsView.onSearchComplete();
        }

        this.resultsBlock.stop();
        this.loading = false;

        //if (this.request.noticeId) {
        //    if (this.results) {
        //        if (this.results.data.length > 0) {
        //            if (this.results.data[0].b2BRef != this.request.noticeId) {
        //                $('#invalid-tender-modal').modal();
        //            }
        //        }
        //    }
        //    else {
        //        $('#invalid-tender-modal').modal();
        //    }

        //    this.request.noticeId = null;
        //}
    }

    showInfoDialog() {
        $('#matching-info-modal').modal();
    }

    public downloadCsv(): void {

        if (this.results.totalRecords > 200) {
            $('#matching-csv-modal').modal();
        }
        else {
            this.continueDownload();
        }
    }

    public continueDownload(): void {
        $('#matching-csv-modal').modal('hide');
        this.clicked = true;
        this.matchingTenderService.downloadCsv(this.request);
        this.clicked = false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/tenders/my.matches.component.ts